import React from "react";
import { useQuery } from "@tanstack/react-query";
import { useApi } from "@core/api";
import { registerExtension } from "@core/components/PipelineComponents/ExtensionProvider";
import { ClientOnly } from "@core/components/client-only";
import { useCurrentUser } from "@core/hooks/useCurrentUser";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGauge } from "@fortawesome/pro-light-svg-icons";

/** Storefront header Admin button — Global Admins only. */
const HeaderAdminLink: React.FC = () => {
  const api = useApi();
  const { user } = useCurrentUser();

  const { data: isGlobalAdmin } = useQuery({
    queryKey: ["roleCheck", "Global Admin"],
    queryFn: () => api["/auth/role-check/{role}"]("Global Admin"),
    staleTime: 5 * 60_000,
    enabled: !!user?.Id,
  });

  if (isGlobalAdmin !== true) return null;

  return (
    <a href="/admin-dashboard" className="header-admin-link">
      <FontAwesomeIcon icon={faGauge} />
      Admin
    </a>
  );
};

const HeaderAdminLinkExtension: React.FC = () => (
  <ClientOnly>
    <HeaderAdminLink />
  </ClientOnly>
);

registerExtension(
  "_site.header.afterOrderingFor",
  HeaderAdminLinkExtension,
  "HeaderAdminLinkExtension",
);
